<template>
  <div class="news-edu-container">
    <!-- 顶部标题区 -->
    <div class="page-header">
      <h1>新闻动态 | 建教融合</h1>
      <p>聚焦湖南省芦淞区中医骨伤专科医院发展，传递党建引领、教学相长的奋进之声</p>
    </div>

    <!-- 新闻动态板块 -->
    <section class="content-section">
      <h2>一、新闻动态</h2>
      <div class="news-list">
        <div 
          class="news-item" 
          v-for="(item, index) in newsList" 
          :key="index"
          @mouseenter="handleMouseEnter(item)"
          @mouseleave="handleMouseLeave(item)"
        >
          <img :src="item.img" alt="新闻图片" class="news-img" :style="item.imgStyle" />
          <div class="news-info">
            <h3 :style="{ color: item.titleColor }">{{ item.title }}</h3>
            <p class="news-desc">{{ item.desc }}</p>
            <span class="news-time">{{ item.time }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 党建+教育融合板块 -->
    <section class="content-section">
      <h2>二、党建引领·教学相长</h2>
      <div class="edu-item">
        <!-- <img 
          src="https://picsum.photos/500/300?random=10" 
          alt="党建教学" 
          class="edu-img"
          @mouseenter="imgScale = 1.05"
          @mouseleave="imgScale = 1"
          :style="{ transform: `scale(${imgScale})`, transition: 'transform 0.3s ease' }"
        /> -->
        <div class="edu-text">
          <p>医院坚持党建与教学深度融合，以党建为魂筑牢育人根基。党支部牵头开展“党建+师承教育”模式，组织党员专家与年轻医师结对，传承中医骨伤诊疗绝技与医德医风。</p>
          <p>通过“党建+学术交流”活动，推动党员骨干带头参与行业研讨、新技术培训，在提升医疗水平的同时，为教学储备优质师资，实现“党建强引领、教学促发展、医疗惠民生”的良性循环。</p>
        </div>
      </div>
    </section>

    <!-- 建教成果展示板块 -->
    <section class="content-section">
      <h2>三、健教成果速递</h2>
      <div class="achievement-list">
        <div class="achievement-card" v-for="(card, idx) in achievementCards" :key="idx">
          <div class="card-header" :style="{ backgroundColor: card.bgColor }">
            <h3>{{ card.title }}</h3>
          </div>
          <div class="card-body">
            <p>{{ card.desc }}</p>
            <span class="card-tag" :style="{ backgroundColor: card.tagBg }">{{ card.tag }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'NewsEducation',
  data() {
    return {
      // 新闻列表，可替换为医院真实新闻数据、图片
      newsList: [
        {
          title: '我院开展社区骨伤义诊活动',
          desc: '党员医护团队走进芦淞区社区，为居民免费筛查骨伤疾病、普及防护知识，深受群众好评',
          time: '2025-06-10',
          img:  require('@/assets/yyimages/正骨6.jpg'),
          imgStyle: { borderRadius: '8px' },
          titleColor: '#dc3545'
        },
        {
          title: '中医骨伤新技术培训顺利举办',
          desc: '邀请行业专家授课，聚焦微创诊疗等前沿技术，助力医护人员提升专业技能',
          time: '2025-05-25',
          img: require('@/assets/yyimages/yyindex-3.png'),
          imgStyle: { borderRadius: '8px' },
          titleColor: '#198754'
        },
        {
          title: '党建知识竞赛激发学习热情',
          desc: '医院党支部组织党员参与知识竞赛，以赛促学强化党建理论，凝聚发展合力',
          time: '2025-05-12',
           img: require('@/assets/yyimages/yyindex-2.png'),
          imgStyle: { borderRadius: '8px' },
          titleColor: '#007bff'
        }
      ],
      imgScale: 1, // 图片缩放控制
      // 建教成果卡片，可替换为医院真实荣誉、项目等
      achievementCards: [
        {
          title: '中医骨伤传承工作室',
          desc: '获批市级传承工作室，党员专家牵头整理古籍验方，培养后备人才',
          tag: '传承创新',
          bgColor: '#dc3545',
          tagBg: '#dc3545'
        },
        {
          title: '教学示范病房建设',
          desc: '打造教学示范病房，党建引领下实现临床与教学场景深度融合',
          tag: '教学实践',
          bgColor: '#17a2b8',
          tagBg: '#17a2b8'
        },
        {
          title: '党员教学能手获奖',
          desc: '党员医师在区级教学竞赛中斩获佳绩，展现建教融合育人成效',
          tag: '人才培养',
          bgColor: '#ffc107',
          tagBg: '#ffc107'
        }
      ]
    }
  },
  methods: {
    handleMouseEnter(item) {
      item.imgStyle.transform = 'scale(1.03)';
      item.imgStyle.transition = 'transform 0.3s ease';
    },
    handleMouseLeave(item) {
      item.imgStyle.transform = 'scale(1)';
    }
  }
}
</script>

<style scoped>
/* 整体容器：白底、居中、阴影修饰 */
.news-edu-container {
  width: 85%;
  max-width: 1280px;
  margin: 30px auto;
  background-color: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  opacity: 0;
  transform: translateY(25px);
  animation: fadeInUp 0.8s forwards;
}

/* 标题区样式：居中、层次分明 */
.page-header {
  text-align: center;
  margin-bottom: 40px;
}
.page-header h1 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 10px;
}
.page-header p {
  color: #777;
}

/* 内容板块通用样式：标题突出、间距合理 */
.content-section {
  margin-bottom: 50px;
}
.content-section h2 {
  font-size: 1.6rem;
  color: #333;
  border-left: 6px solid #007bff;
  padding-left: 12px;
  margin-bottom: 25px;
}

/* 新闻列表布局：卡片化展示 */
.news-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
}
.news-item {
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  transition: box-shadow 0.3s ease;
}
.news-item:hover {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
}
.news-img {
  width: 250px;
  height: auto;
  object-fit: cover;
}
.news-info {
  flex: 1;
}
.news-info h3 {
  margin-bottom: 10px;
  font-size: 1.25rem;
}
.news-desc {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.news-time {
  color: #999;
  font-size: 0.9rem;
}

/* 党建+教育板块布局：图文呼应 */
.edu-item {
  display: flex;
  align-items: center;
  gap: 30px;
  background-color: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
}
.edu-img {
  width: 40%;
  height: auto;
  border-radius: 8px;
}
.edu-text {
  flex: 1;
  color: #666;
  line-height: 1.7;
}

/* 建教成果卡片样式：色彩区分、模块化 */
.achievement-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
}
.achievement-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: transform 0.3s ease;
}
.achievement-card:hover {
  transform: translateY(-5px);
}
.card-header {
  padding: 15px;
  color: #fff;
}
.card-body {
  padding: 20px;
  color: #555;
  line-height: 1.6;
}
.card-tag {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 4px;
  color: #fff;
  font-size: 0.85rem;
  margin-top: 10px;
}

/* 入场动画：渐变上移 */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配：不同屏幕下布局调整 */
@media (max-width: 992px) {
  .news-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .news-img {
    width: 100%;
    margin-bottom: 15px;
  }
  .edu-item {
    flex-direction: column;
  }
  .edu-img {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>